import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import classNames from 'classnames';
import './style.css';

interface IProps {
  children: ReactNode;
  level?: 'nav';
  className?: string;
  style?: React.CSSProperties;
  href?: string;
  target?: string;
  rel?: string;
}

const List = ({
  children,
  level = 'nav',
  className,
  ...props
}: IProps): ReactElement => {
  const listClasses = classNames('list', {
    [`list--${level}`]: level,
    [`${className}`]: className,
  });

  return (
    <a className={listClasses} {...props}>
      {children}
    </a>
  );
};

export default List;
